var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState, useContext, createContext, useCallback, } from "react";
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { AuthContext } from "./AuthContextProvider";
import { Box, CircularProgress } from "@mui/material";
import { ApolloProvider } from "@apollo/client";
import { useParams } from "react-router-dom";
import { SettingsContext } from "./SettingsContextProvider";
import { ELanguageDetectionPolicy } from "@sequentech/ui-core";
var defaultApolloContextValues = {
    apolloClient: null,
};
/**
 * Create the AuthContext using the default values.
 */
export var ApolloContext = createContext(defaultApolloContextValues);
export var ApolloContextProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), apolloClient = _b[0], setApolloClient = _b[1];
    var _c = useContext(AuthContext), isAuthenticated = _c.isAuthenticated, getAccessToken = _c.getAccessToken, login = _c.login;
    var _d = useParams(), tenantId = _d.tenantId, eventId = _d.eventId;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var electionEventConfigUrl = "".concat(globalSettings.PUBLIC_BUCKET_URL, "tenant-").concat(tenantId, "/event-").concat(eventId, "/election_event_config.json");
    // Set up tenant and event in AuthContext on initial load.
    // It is needed to fetch the election event config file from S3
    // and apply the language policy before loading any other data.
    var setupLogin = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, config, presentation, languageConf, defaultLocale, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!tenantId || !eventId) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(electionEventConfigUrl)];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("HTTP ".concat(response.status));
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    config = (_a.sent());
                    presentation = config.election_event_presentation;
                    languageConf = presentation === null || presentation === void 0 ? void 0 : presentation.language_conf;
                    defaultLocale = (languageConf === null || languageConf === void 0 ? void 0 : languageConf.language_detection_policy) === ELanguageDetectionPolicy.FORCE_DEFAULT
                        ? languageConf.default_language_code
                        : undefined;
                    login(tenantId, eventId, defaultLocale);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error("Error loading election event config:", error_1);
                    login(tenantId, eventId, undefined);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [tenantId, eventId, electionEventConfigUrl, location.pathname, login]);
    useEffect(function () {
        if (!globalSettings.DISABLE_AUTH && !isAuthenticated && tenantId && eventId) {
            void setupLogin();
        }
    }, [isAuthenticated, tenantId, eventId, globalSettings.DISABLE_AUTH]);
    var createApolloClient = function () {
        var httpLink = createHttpLink({
            uri: globalSettings.HASURA_URL,
        });
        var authLink = setContext(function (_, _a) {
            var headers = _a.headers;
            // get the authentication token from local storage if it exists
            var token = getAccessToken();
            // return the headers to the context so httpLink can read them
            return {
                headers: __assign(__assign({}, headers), { authorization: token ? "Bearer ".concat(token) : "" }),
            };
        });
        var apolloClient = new ApolloClient({
            link: authLink.concat(httpLink),
            cache: new InMemoryCache(),
        });
        return apolloClient;
    };
    useEffect(function () {
        if (apolloClient || (!globalSettings.DISABLE_AUTH && !isAuthenticated)) {
            return;
        }
        var token = getAccessToken();
        if (!globalSettings.DISABLE_AUTH && !token) {
            return;
        }
        var newClient = createApolloClient();
        setApolloClient(newClient);
    }, [isAuthenticated, apolloClient, globalSettings.DISABLE_AUTH]);
    // Setup the context provider
    return (_jsx(ApolloContext.Provider, { value: {
            apolloClient: apolloClient,
        }, children: children }));
};
export var ApolloWrapper = function (_a) {
    var children = _a.children;
    var apolloClient = useContext(ApolloContext).apolloClient;
    return (_jsx(_Fragment, { children: null === apolloClient ? (_jsx(Box, { children: _jsx(CircularProgress, {}) })) : (_jsx(ApolloProvider, { client: apolloClient, children: children })) }));
};
